export let itemListProps = {
    key: 0,
    id: 0,
    production_id: null,
    item_detail: null
}

export let dataProps = {
    id: 0,
    challan_number: null, 
    challan_date: new Date(), 
    delivered_by_staff_id: null, 
    notes: '',
    personal_remarks: '', 
    customer_id: null, 
    salutation_name: null,
    customer_name: null,
    approved_by_staff_id: null,
    shipment_partner_id: null,
    mail_customer: false,
    customer_shipping_address_id: 0,
    photo: '',
    otp: '',
    item_list: [JSON.parse(JSON.stringify(itemListProps))],
    pending_list: []
}


// WEBPACK FOOTER //
// ./src/store/modules/saleDelivery/properties.js